var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "w-btn-icon",
    _vm._g(
      _vm._b(
        { staticClass: "w-btn-close" },
        "w-btn-icon",
        { size: _vm.size, hover: _vm.hover, hoverAction: _vm.hoverAction },
        false
      ),
      _vm.$listeners
    ),
    [_c("i-close", { attrs: { title: "close" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }